import React, { useState, useEffect } from "react";
import styled from "styled-components"; 
import { Modal, Button, SelectPicker } from "rsuite";
import Logger from "../../libraries/Logger";
 
function LoadingModal({ isOpen }) { 
  const [open, setOpen] = useState(isOpen); 
  
  useEffect(() => { 
    setOpen(isOpen); 
  }, [isOpen]);


  return (
    <> 
      <Modal open={open}>
        <Modal.Header closeButton={false}>
          <Modal.Title>資料讀取中</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            正在讀取資料中，請稍後
        </Modal.Body>
        <Modal.Footer> 
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LoadingModal;
